import { useDispatch } from 'react-redux';

import { setFeatureFlags } from 'store/actions/featureFlag';

function useFeatureFlag() {
  const dispatch = useDispatch();

  function fetchFeatureFlags({ userId, auth }) {
    dispatch(setFeatureFlags({ userId, auth }));
  }

  return { fetchFeatureFlags };
}

export default useFeatureFlag;
